export const users = {
  title: 'Users',
  loading: 'Loading users...',
  error: 'Failed to load users.',
  list: {
    searchPlaceholder: 'Search by name or email…',
    empty: {
      title: 'No users yet',
    },
    noResults: {
      title: 'No users found',
      description: 'Adjust your search or filters to see results again.',
      reset: 'Reset search and filters',
    },
    columns: {
      person: 'Person',
      groups: 'Groups',
      status: 'Status',
    },
    result: { singular: 'user', plural: 'users' },
  },
  state: {
    Active: 'Active',
    Invited: 'Invited',
    Pending: 'Pending',
    Deactivated: 'Deactivated',
  },
  detail: {
    title: 'User',
    back: 'All Users',
    error: 'Failed to load user.',
    cards: {
      identity: 'Identity',
      access: 'Access',
    },
    fields: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      groups: 'Groups',
      state: 'Status',
    },
    groupsField: {
      empty: 'No groups in this tenant yet.',
      loading: 'Loading groups…',
      error: 'Failed to load groups.',
    },
    actions: {
      activate: 'Activate user',
      deactivate: 'Deactivate user',
      selfExplanation: 'You cannot deactivate your own account.',
      editGroups: 'Edit groups',
      save: 'Save',
      saving: 'Saving…',
      cancel: 'Cancel',
      selfEditExplanation: 'You cannot edit your own group membership.',
    },
    toast: {
      activated: 'User activated',
      deactivated: 'User deactivated',
      groupsUpdated: 'Groups updated',
    },
    deactivateConfirm: {
      title: 'Deactivate {{name}}?',
      description: 'The user loses access to this tenant, but their record is kept.',
      cancel: 'Cancel',
      confirm: 'Deactivate',
    },
    unsavedChanges: {
      title: 'Discard your changes?',
      description: 'Your changes to this user’s groups have not been saved.',
      keepEditing: 'Keep editing',
      discard: 'Discard',
    },
  },
};

export type UsersResources = typeof users;
